export default __webpack_public_path__ + "static/media/Medium's Bracers of the Emissary.78e2e4ed.jpg";